export const overrideMarks: string[] = ['backgroundColor'];

export const ACCESSIBLE_CONTRAST_RATIO = 4.5;
export const DIFFICULT_CONTRAST_RATIO = 3;

export const DEFAULT_BACKGROUND_COLOR = '#FFFFFF';
export const TRANSPARENT_HIGHLIGHT_COLOR = '#00000000';
export const DEFAULT_COLOR: {
	color: string;
	label: string;
} = {
	// TODO: DSP-4137 - Remove usage of hardcoded color
	/* eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage */
	color: '#172b4d',
	label: 'Dark gray',
};
